import { render, staticRenderFns } from "./InviteTeamMemberModal.vue?vue&type=template&id=01c8fc4c&scoped=true"
import script from "./InviteTeamMemberModal.vue?vue&type=script&lang=js"
export * from "./InviteTeamMemberModal.vue?vue&type=script&lang=js"
import style0 from "./InviteTeamMemberModal.vue?vue&type=style&index=0&id=01c8fc4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c8fc4c",
  null
  
)

export default component.exports